module.exports = __webpack_public_path__ + "static/media/key.9bf7ac82.svg";